import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { organizationApi } from "../api/organization.api";
import { organizationQueryKeys } from "../api/organization.query-keys";

export const organizationsQueryOptions = () => queryOptions({
    queryKey: organizationQueryKeys.list(),
    queryFn: async () => {
        const { data, error } = await organizationApi.getOrganizations();
        if (error) throw error;
        return data.items
    }
})

export const useOrganizations = () => useSuspenseQuery(organizationsQueryOptions());